import axios from "axios";
import { getBaseUrl, API_ENDPOINTS } from "./api.config";

const axiosInstance = axios.create({
  baseURL: getBaseUrl(),
});

// =======================
// REQUEST INTERCEPTOR
// =======================
axiosInstance.interceptors.request.use(
  (config) => {
    const authUser = JSON.parse(localStorage.getItem("auth_user"));
    const token =
      authUser?.accessToken ||
      authUser?.access ||
      authUser?.token;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// =======================
// RESPONSE INTERCEPTOR
// =======================
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Do not force redirect for login request failures.
    if (
      originalRequest?.url?.includes(API_ENDPOINTS.AUTH.LOGIN) ||
      originalRequest?.url?.endsWith(API_ENDPOINTS.AUTH.LOGIN)
    ) {
      return Promise.reject(error);
    }

    if (error.response?.data?.code === "token_not_valid" || error.response?.status === 401) {
      const authUser = JSON.parse(localStorage.getItem("auth_user"));
      const refreshToken = authUser?.refreshToken || authUser?.refresh;

      // If refresh token exists → try refresh
      if (refreshToken && !originalRequest._retry) {
        originalRequest._retry = true;

        try {
          const { getBaseUrl } = require("./api.config");
          const res = await axios.post(
            `${getBaseUrl()}auth/refresh/`,
            {
              refresh: refreshToken,
            }
          );

          const newAccessToken = res.data.access;

          // update storage
          const updatedUser = {
            ...authUser,
            accessToken: newAccessToken,
            access: newAccessToken,
          };

          localStorage.setItem("auth_user", JSON.stringify(updatedUser));

          // retry original request
          originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
          return axiosInstance(originalRequest);
        } catch (refreshError) {
          localStorage.removeItem("auth_user");
          window.location.href = "/sessions/signin";
        }
      } else {
        localStorage.removeItem("auth_user");
        window.location.href = "/sessions/signin";
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;